import React from 'react'

import { Flex, Text, RadioGroup } from 'components/ds'
import { FilterOperator, FilterOperatorOption } from 'types/filter-page'
import { formatComparisonOperator } from 'components/search/search-filters/utils'

type Props = {
  operator: FilterOperator
  operators: FilterOperatorOption[]
  onChange: (value: any, operator: FilterOperator) => void
}

export const FilterOperatorSelector = ({
  operator,
  onChange,
  operators,
}: Props) => {
  return (
    <RadioGroup.Root
      value={operator}
      onValueChange={newOperator => {
        onChange(undefined, newOperator as FilterOperator)
      }}
    >
      <Flex gap="4" direction="column">
        {operators.map(option => (
          <RadioGroup.Item
            value={option.value}
            key={option.value}
            style={{
              width: '100%',
            }}
          >
            <Flex gap="2" direction="column">
              <Text>
                {option.label ?? formatComparisonOperator(option.value)}
              </Text>
              {option.value === operator && <span>{option.component}</span>}
            </Flex>
          </RadioGroup.Item>
        ))}
      </Flex>
    </RadioGroup.Root>
  )
}
